<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zi1OlR/tc-custom/9781604604290.jpg?1704761522567" alt="This image is the cover for the book Everlasting Quilts, East Perry County Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everlasting Quilts, East Perry County Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Innkeeper Kate Meyr learns what is fleeting and what is enduring in a poignant East Perry County mystery from the author of <i>Quilt the Town Christmas</i>.</b><br/><br/>Complicated and confusing romance continues for Josephine’s Guest House proprietor Kate Meyr in <i>Everlasting Quilts</i>, the fourth novel in the East Perry County series. John Baker, Kate’s lakehouse neighbor, a writer, and wannabe lover intrigues Kate with his research on quilts for a magazine article. In the process, she discovers unusual destinations for quilts, even in her own family. These stories are precious and everlasting. <br/><br/>But not all is precious in Borna as Kate faces a fight for her life in her beloved home. Thanks to the spirit of Josephine and a handsome new acquaintance, Kate is able to persevere. It’s once again another secret that Kate has to keep from her community as she continues to protect her guest house’s reputation.<br/><br/><b>Praise for Ann Hazelwood and her novels</b><br/><br/>“I found myself immersed in the tale of this extended family and this wonderful quaint town . . . You will laugh, cry and share in their hopes and dreams.” —<i>Community News</i><br/><br/>“Ann Hazelwood knows a few things about the human spirit, family and dreaming big. Add a mixture of the love of quilting and all the things Missouri historic and otherwise; you will experience the words and passion of this unique and gifted author. Enjoy the experience!” —<i>StreetScape Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Hazelwood
      </h2>
      
      <p class="authorDescription body article">Ann Hazelwood is a former shop owner and native of St. Charles, Missouri. She's always adored quilting and is a certified quilt appraiser. She's the author of the wildly successful Colebridge Community series and considers writing one of her greatest passions. Titles include: Colebridge Community series - The Basement Quilt, The Potting Shed Quilt, The Funeral Parlor Quilt, The Jane Austen Quilt Club, The Ghostly Quilts on Main, Quilted Lilies, A Colebridge Quilted Christmas.  She has also published the Wine Country Quilt Series, East Perry County series and is now writing the Door County Quilt series. booksonthings.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15d6ac8d